import { render, staticRenderFns } from "./JourneyBody.vue?vue&type=template&id=a9c9862e&lang=pug&"
import script from "./JourneyBody.vue?vue&type=script&lang=js&"
export * from "./JourneyBody.vue?vue&type=script&lang=js&"
import style0 from "./JourneyBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports